export default "__VITE_ASSET__BAQ_svx6__"